import React, { FunctionComponent, useEffect, useState } from "react";

import { useSelector } from "react-redux";
import { useLoadIfEmpty } from "../../hooks/useLoadIfEmpty";
import { thunkFetchTenantTypes } from "../../store/tenants/actions";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectProps
} from "@material-ui/core";
import { AppState } from "../../store";
import { Category, CategoryId } from "../../models/Product";
import { TenantType } from "../../models/Tenant";

interface TenantTypeSelectProps extends Omit<SelectProps, "loading"> {
  label?: string;
  onSelected?: (value: TenantType) => void;
  variant?: "filled" | "outlined" | "standard";
  value?: number;
  error?: boolean;
}

export const TenantTypeSelect: FunctionComponent<TenantTypeSelectProps> = ({
  label = "Tenant type",
  onSelected,
  onChange,
  variant = "standard",
  value,
  error = false,
  ...props
}) => {
  const tenantTypes =
    useSelector<AppState, ReadonlyArray<TenantType>>(s => s.tenants.types) ||
    [];

  const [state, setState] = useState<ReadonlyArray<TenantType>>([]);

  useLoadIfEmpty(!tenantTypes.length, thunkFetchTenantTypes);

  const handleChange = (
    event: React.ChangeEvent<{ name?: string; value: unknown }>,
    child: React.ReactNode
  ) => {
    if (onSelected) {
      let tenantType = state.find(c => c.id === event.target.value);
      if (tenantType) {
        onSelected(tenantType);
      }
    }
    if (onChange) {
      onChange(event, child);
    }
  };

  useEffect(() => {
    setState(tenantTypes);
  }, [tenantTypes]);

  return (
    <FormControl
      disabled={props.disabled}
      required={props.required}
      variant={variant}
      className={props.className}
      error={error}
    >
      <InputLabel
        id="category-select-label"
        style={
          variant === "outlined"
            ? {
                backgroundColor: "#fff",
                paddingLeft: "0.5rem",
                paddingRight: "0.5rem"
              }
            : undefined
        }
      >
        {label}
      </InputLabel>
      <Select
        value={value}
        onChange={handleChange}
        labelId="tenant-type-select-label"
        id="tenant-type-select"
        autoWidth={true}
      >
        {state &&
          state.length > 0 &&
          state.map(x => (
            <MenuItem key={x.id} value={x.id}>
              {x.name}
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  );
};
